<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'NewsCenter',
          to: {
            name: 'NewsCenter'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'NewsEdit',
            params: {
              id: $route.params.id
            }
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>修改文章</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- Block 新增文章 -->
    <NewsCreateEdit></NewsCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import NewsCreateEdit from '@/views/E-4__News/c/NewsCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    NewsCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('news', ['news']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getNews(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('news', {
      getNews: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'NewsCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.news).then(() => {
          this.$router.push({ name: 'NewsCenter' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
